import { Instagram, ArrowUpRight } from "lucide-react";
import { BOOKING_URL, CONTACT, LOGO_URL, SOCIALS } from "../lib/data";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-brown-dark text-cream pt-20 pb-10 overflow-hidden"
    >
      <div className="lilac-blur" style={{ top: "-300px", right: "-200px", opacity: 0.25 }} />

      <div className="max-w-7xl mx-auto px-6 md:px-10 relative z-10">
        <div className="grid md:grid-cols-12 gap-12 items-start">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <img
                src={LOGO_URL}
                alt="Barks & Co"
                className="h-16 w-16 rounded-full ring-1 ring-cream/20"
              />
              <div>
                <div className="font-serif text-3xl">Barks &amp; Co</div>
                <div
                  className="eyebrow mt-1"
                  style={{ color: "rgba(249, 246, 240, 0.7)" }}
                >
                  Boutique Dog Grooming Salon
                </div>
              </div>
            </div>
            <p className="mt-7 text-cream/75 max-w-md leading-relaxed">
              A private one-on-one boutique grooming service, dedicated to
              giving every pup the calm, careful spa day they deserve.
            </p>

            <a
              href={BOOKING_URL}
              data-testid="footer-book-button"
              className="inline-flex items-center gap-2 mt-8 px-6 py-3 rounded-full bg-cream text-brown-dark font-medium hover:bg-lilac hover:text-brown-dark transition-all"
            >
              Join The Waitlist
              <ArrowUpRight size={16} />
            </a>
          </div>

          <div className="md:col-span-3">
            <div
              className="eyebrow mb-5"
              style={{ color: "rgba(249, 246, 240, 0.7)" }}
            >
              Explore
            </div>
            <ul className="space-y-3 font-serif text-lg">
              <li><a href="#about" className="hover:text-lilac transition-colors" data-testid="footer-link-about">About</a></li>
              <li><a href="#services" className="hover:text-lilac transition-colors" data-testid="footer-link-services">Services</a></li>
              <li><a href="#gallery" className="hover:text-lilac transition-colors" data-testid="footer-link-gallery">Gallery</a></li>
              <li><a href="#faq" className="hover:text-lilac transition-colors" data-testid="footer-link-faq">FAQ</a></li>
              <li><a href="#contact" className="hover:text-lilac transition-colors" data-testid="footer-link-contact">Contact</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div
              className="eyebrow mb-5"
              style={{ color: "rgba(249, 246, 240, 0.7)" }}
            >
              Get In Touch
            </div>
            <ul className="space-y-3 text-cream/85">
              <li>
                <a
                  href={`mailto:${CONTACT.email}`}
                  data-testid="footer-email"
                  className="hover:text-lilac transition-colors break-all"
                >
                  {CONTACT.email}
                </a>
              </li>
              <li className="text-cream/65 text-sm pt-1">
                Auckland, NZ · By appointment only
              </li>
            </ul>

            <div className="flex items-center gap-3 mt-6">
              <a
                href={SOCIALS.instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                data-testid="footer-instagram"
                className="h-10 w-10 rounded-full bg-cream/10 hover:bg-lilac hover:text-brown-dark flex items-center justify-center transition-all"
              >
                <Instagram size={16} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-7 border-t border-cream/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-cream/60 text-sm">
            © {year} Barks &amp; Co Dog Grooming. All rights reserved.
          </p>
          <p className="text-cream/50 text-xs font-serif italic">
            Made with love, for the floofiest of clients.
          </p>
        </div>
      </div>
    </footer>
  );
}
